module.exports = __webpack_public_path__ + "static/media/co.523779d4.svg";